import { Controller } from "stimulus"
import { activateReload } from "mz_ui/utils/activate_link"

export default class extends Controller {
  connect() {
    activateReload(this.element)
  }
}
